import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import ContactInfo from '../components/contact/ContactInfo';
import ContactForm from '../components/contact/ContactForm';
import { useScrollReveal } from '../utils/hooks/useScrollReveal';
import './ContactPage.css';

const ContactPage = () => {
  const { t } = useTranslation();
  const contactRef = useScrollReveal();

  return (
    <>
      <Header />
      <main>
        <section className="contact-hero">
          <div className="container">
            <h1>{t('contact.title')}</h1>
            <p>{t('contact.subtitle')}</p>
          </div>
        </section>

        <section ref={contactRef} className="contact-section scroll-reveal">
          <div className="container">
            <div className="contact-layout">
              <ContactInfo />
              <ContactForm />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default ContactPage;
